import React, { useState, useEffect } from 'react'
import { Box, Icon, Text } from '@deseretbook/react-ui'
import { dailyQuote } from '../../api/content/messages'

import './Quote.css'

const Quote = () => {
  const [dailyQuoteData, setDailyQuoteData] = useState({})
  const getDailyQuote = async () => {
    try {
      const response = await dailyQuote()
      setDailyQuoteData((response && response.quote) || {})
    } catch (error) {
      console.error('Error fetching discovery data:', error)
    }
  }

  useEffect(() => {
    getDailyQuote()
  }, [])

  const quoteStr = (dailyQuoteData && dailyQuoteData.quote) || ''
  const quoteAuthor = dailyQuoteData && dailyQuoteData.authors && dailyQuoteData.authors[0]
  const quoteAuthorName = quoteAuthor ? `${quoteAuthor.firstName} ${quoteAuthor.lastName}` : ''
  const sourceName = dailyQuoteData && dailyQuoteData.source
  const sourceUrl = dailyQuoteData && dailyQuoteData.sourceURL

  return (
    <>
      {quoteStr && (
        <Box id="QuoteContainer" alignItems="stretch" justifyContent="flex-start" isFullwidth>
          <Box alignItems="center" className="quote-background">
            <Icon
              className="quote-icon"
              name="quote"
              svgProps={{
                style: {
                  width: '56px',
                  height: '56px',
                },
              }}
            />
          </Box>
          <Box style={{ margin: '32px' }}>
            <Text className="quote-text">"{quoteStr}"</Text>
            <Box alignItems="center" justifyContent="flex-start" style={{ marginTop: '16px' }}>
              <Box className="quote-author-container">
                <Icon
                  name="profile"
                  className="quote-author-icon"
                  svgProps={{
                    style: {
                      color: '#0F8079',
                      fill: '#0F8079',
                      width: '40px',
                      height: '40px',
                    },
                  }}
                />
              </Box>
              <Box isColumn alignItems="flex-start">
                <Text className="quote-author-name">{quoteAuthorName.toUpperCase()}</Text>
                <Box alignItems="center" justifyContent="flex-start">
                  <Text href={sourceUrl} as="a" target="_blank" className="quote-source-name">
                    {sourceName}
                  </Text>
                  <Icon name="chevronRight" style={{ marginLeft: '4px', color: '#0F8079' }} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}

export default Quote
